export const PageShell = ({ title, subtitle, children, action }) => {
  return (
    <div className="px-4 pt-10 pb-28 min-h-screen nrt-fade">
      <header className="mb-6 flex items-start justify-between gap-3">
        <div>
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-zinc-50">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-zinc-400 mt-1">{subtitle}</p>
          )}
        </div>
        {action}
      </header>
      {children}
    </div>
  );
};
